export const pageData = {
  "pages": [
    {
      "title": "Creating Plugins",
      "routePath": "/extending/plugin-api",
      "lang": "en",
      "toc": [
        {
          "id": "scaffolding",
          "text": "Scaffolding",
          "depth": 2,
          "charIndex": 194
        },
        {
          "id": "the-traceplugin-interface",
          "text": "The `TracePlugin` interface",
          "depth": 2,
          "charIndex": 521
        },
        {
          "id": "slots",
          "text": "Slots",
          "depth": 3,
          "charIndex": 881
        },
        {
          "id": "minimal-example",
          "text": "Minimal example",
          "depth": 2,
          "charIndex": 1352
        },
        {
          "id": "hooks",
          "text": "Hooks",
          "depth": 2,
          "charIndex": 1706
        },
        {
          "id": "useprojectroot",
          "text": "`useProjectRoot()`",
          "depth": 3,
          "charIndex": 1766
        },
        {
          "id": "useinspectoractive",
          "text": "`useInspectorActive()`",
          "depth": 3,
          "charIndex": 1865
        },
        {
          "id": "usedeactivateinspector",
          "text": "`useDeactivateInspector()`",
          "depth": 3,
          "charIndex": 1992
        },
        {
          "id": "useselectedcontext",
          "text": "`useSelectedContext()`",
          "depth": 3,
          "charIndex": 2199
        },
        {
          "id": "useclearselectedcontext",
          "text": "`useClearSelectedContext()`",
          "depth": 3,
          "charIndex": 2597
        },
        {
          "id": "useselectedsource",
          "text": "`useSelectedSource()`",
          "depth": 3,
          "charIndex": 2752
        },
        {
          "id": "usewidgetportalcontainer",
          "text": "`useWidgetPortalContainer()`",
          "depth": 3,
          "charIndex": 3229
        },
        {
          "id": "utilities-and-constants",
          "text": "Utilities and constants",
          "depth": 2,
          "charIndex": 3683
        },
        {
          "id": "types",
          "text": "Types",
          "depth": 2,
          "charIndex": 4247
        },
        {
          "id": "production-stubs",
          "text": "Production stubs",
          "depth": 2,
          "charIndex": 5092
        },
        {
          "id": "tips",
          "text": "Tips",
          "depth": 2,
          "charIndex": 5552
        }
      ],
      "frontmatter": {
        "description": "Build custom React Trace plugins — the TracePlugin interface, available hooks, shared state, scaffolding CLI, and production stub conventions."
      },
      "version": "",
      "_relativePath": "extending/plugin-api.mdx",
      "description": "Build custom React Trace plugins — the TracePlugin interface, available hooks, shared state, scaffolding CLI, and production stub conventions."
    },
    {
      "title": "UI Components",
      "routePath": "/extending/ui-components",
      "lang": "en",
      "toc": [
        {
          "id": "installation",
          "text": "Installation",
          "depth": 2,
          "charIndex": 113
        },
        {
          "id": "available-components",
          "text": "Available components",
          "depth": 2,
          "charIndex": 319
        },
        {
          "id": "action-and-input-primitives",
          "text": "Action and input primitives",
          "depth": 3,
          "charIndex": 344
        },
        {
          "id": "layout-and-helpers",
          "text": "Layout and helpers",
          "depth": 3,
          "charIndex": 750
        },
        {
          "id": "overlay-and-selection-primitives",
          "text": "Overlay and selection primitives",
          "depth": 3,
          "charIndex": 1309
        },
        {
          "id": "icons",
          "text": "Icons",
          "depth": 3,
          "charIndex": 2052
        },
        {
          "id": "logo",
          "text": "Logo",
          "depth": 3,
          "charIndex": 2412
        },
        {
          "id": "example",
          "text": "Example",
          "depth": 2,
          "charIndex": 2464
        },
        {
          "id": "guidelines",
          "text": "Guidelines",
          "depth": 2,
          "charIndex": 3083
        }
      ],
      "frontmatter": {
        "description": "UI component library for React Trace plugins — buttons, tooltips, popovers, dropdowns, icons, and layout primitives that match the widget's look and feel."
      },
      "version": "",
      "_relativePath": "extending/ui-components.mdx",
      "description": "UI component library for React Trace plugins — buttons, tooltips, popovers, dropdowns, icons, and layout primitives that match the widget's look and feel."
    },
    {
      "title": "Configuration",
      "routePath": "/guide/configuration",
      "lang": "en",
      "toc": [
        {
          "id": "react-tracekit-props",
          "text": "`@react-trace/kit` props",
          "depth": 2,
          "charIndex": 0
        },
        {
          "id": "editor-presets",
          "text": "Editor presets",
          "depth": 3,
          "charIndex": 1605
        },
        {
          "id": "example",
          "text": "Example",
          "depth": 3,
          "charIndex": 1734
        },
        {
          "id": "react-tracecore-props",
          "text": "`@react-trace/core` props",
          "depth": 2,
          "charIndex": 1992
        },
        {
          "id": "example-1",
          "text": "Example",
          "depth": 3,
          "charIndex": 2846
        },
        {
          "id": "the-root-prop",
          "text": "The `root` prop",
          "depth": 2,
          "charIndex": 3151
        }
      ],
      "frontmatter": {
        "description": "Configure React Trace props — toolbar position, editor presets, editing controls, and plugin options for both @react-trace/kit and @react-trace/core."
      },
      "version": "",
      "_relativePath": "guide/configuration.mdx",
      "description": "Configure React Trace props — toolbar position, editor presets, editing controls, and plugin options for both @react-trace/kit and @react-trace/core."
    },
    {
      "title": "Introduction",
      "routePath": "/guide/",
      "lang": "en",
      "toc": [
        {
          "id": "how-it-works",
          "text": "How it works",
          "depth": 2,
          "charIndex": 285
        },
        {
          "id": "two-installation-paths",
          "text": "Two installation paths",
          "depth": 2,
          "charIndex": 921
        },
        {
          "id": "zero-production-cost",
          "text": "Zero production cost",
          "depth": 2,
          "charIndex": 1201
        },
        {
          "id": "next-steps",
          "text": "Next steps",
          "depth": 2,
          "charIndex": 1451
        }
      ],
      "frontmatter": {
        "description": "Learn how React Trace works — hover to inspect components, view props and source locations, and run plugin actions like code preview and editor integration."
      },
      "version": "",
      "_relativePath": "guide/index.mdx",
      "description": "Learn how React Trace works — hover to inspect components, view props and source locations, and run plugin actions like code preview and editor integration."
    },
    {
      "title": "Installation",
      "routePath": "/guide/installation",
      "lang": "en",
      "toc": [
        {
          "id": "recommended-react-tracekit",
          "text": "Recommended: `@react-trace/kit`",
          "depth": 2,
          "charIndex": 0
        },
        {
          "id": "setup",
          "text": "Setup",
          "depth": 3,
          "charIndex": 266
        },
        {
          "id": "alternative-react-tracecore-and-specific-plugins",
          "text": "Alternative: `@react-trace/core` and specific plugins",
          "depth": 2,
          "charIndex": 844
        },
        {
          "id": "which-to-choose",
          "text": "Which to choose?",
          "depth": 2,
          "charIndex": 1489
        }
      ],
      "frontmatter": {
        "description": "Install React Trace with @react-trace/kit for a batteries-included setup, or use @react-trace/core with individual plugins for full control."
      },
      "version": "",
      "_relativePath": "guide/installation.mdx",
      "description": "Install React Trace with @react-trace/kit for a batteries-included setup, or use @react-trace/core with individual plugins for full control."
    },
    {
      "title": "Production Stubs",
      "routePath": "/guide/production-stubs",
      "lang": "en",
      "toc": [
        {
          "id": "how-it-works",
          "text": "How it works",
          "depth": 2,
          "charIndex": 145
        },
        {
          "id": "what-gets-stubbed",
          "text": "What gets stubbed",
          "depth": 2,
          "charIndex": 693
        },
        {
          "id": "adding-stubs-to-new-packages",
          "text": "Adding stubs to new packages",
          "depth": 2,
          "charIndex": 1110
        }
      ],
      "frontmatter": {
        "description": "How React Trace achieves zero production cost — conditional exports resolve to no-op stubs in production builds, adding no runtime overhead."
      },
      "version": "",
      "_relativePath": "guide/production-stubs.mdx",
      "description": "How React Trace achieves zero production cost — conditional exports resolve to no-op stubs in production builds, adding no runtime overhead."
    },
    {
      "title": "React Trace",
      "routePath": "/",
      "lang": "en",
      "toc": [],
      "frontmatter": {
        "pageType": "home",
        "title": "React Trace",
        "description": "A development-time React inspector that helps you identify rendered components, resolve their source locations, and run source-aware actions."
      },
      "version": "",
      "_relativePath": "index.mdx",
      "description": "A development-time React inspector that helps you identify rendered components, resolve their source locations, and run source-aware actions."
    },
    {
      "title": "Comments Plugin",
      "routePath": "/plugins/comments",
      "lang": "en",
      "toc": [
        {
          "id": "installation",
          "text": "Installation",
          "depth": 2,
          "charIndex": 271
        },
        {
          "id": "usage",
          "text": "Usage",
          "depth": 2,
          "charIndex": 472
        },
        {
          "id": "what-it-adds",
          "text": "What it adds",
          "depth": 2,
          "charIndex": 656
        },
        {
          "id": "toolbar",
          "text": "Toolbar",
          "depth": 3,
          "charIndex": 673
        },
        {
          "id": "opencode-integration",
          "text": "OpenCode integration",
          "depth": 4,
          "charIndex": 1013
        },
        {
          "id": "action-panel",
          "text": "Action panel",
          "depth": 3,
          "charIndex": 1291
        },
        {
          "id": "api",
          "text": "API",
          "depth": 2,
          "charIndex": 1652
        }
      ],
      "frontmatter": {
        "description": "Comments plugin for React Trace — add inline review comments anchored to components, then copy them to the clipboard or send directly to OpenCode."
      },
      "version": "",
      "_relativePath": "plugins/comments.mdx",
      "description": "Comments plugin for React Trace — add inline review comments anchored to components, then copy them to the clipboard or send directly to OpenCode."
    },
    {
      "title": "Copy to Clipboard Plugin",
      "routePath": "/plugins/copy-to-clipboard",
      "lang": "en",
      "toc": [
        {
          "id": "installation",
          "text": "Installation",
          "depth": 2,
          "charIndex": 229
        },
        {
          "id": "usage",
          "text": "Usage",
          "depth": 2,
          "charIndex": 439
        },
        {
          "id": "copied-output",
          "text": "Copied output",
          "depth": 2,
          "charIndex": 652
        }
      ],
      "frontmatter": {
        "description": "Copy to Clipboard plugin for React Trace — copy the selected component's source location as a project-relative path:lineNumber reference."
      },
      "version": "",
      "_relativePath": "plugins/copy-to-clipboard.mdx",
      "description": "Copy to Clipboard plugin for React Trace — copy the selected component's source location as a project-relative path:lineNumber reference."
    },
    {
      "title": "Plugins",
      "routePath": "/plugins/",
      "lang": "en",
      "toc": [
        {
          "id": "official-plugins",
          "text": "Official plugins",
          "depth": 2,
          "charIndex": 156
        },
        {
          "id": "using-plugins-with-react-tracecore",
          "text": "Using plugins with `@react-trace/core`",
          "depth": 2,
          "charIndex": 1243
        },
        {
          "id": "building-your-own",
          "text": "Building your own",
          "depth": 2,
          "charIndex": 1736
        }
      ],
      "frontmatter": {
        "description": "Overview of React Trace's plugin system — four official plugins for source preview, comments, clipboard, and editor integration, all included in @react-trace/kit."
      },
      "version": "",
      "_relativePath": "plugins/index.mdx",
      "description": "Overview of React Trace's plugin system — four official plugins for source preview, comments, clipboard, and editor integration, all included in @react-trace/kit."
    },
    {
      "title": "Open Editor Plugin",
      "routePath": "/plugins/open-editor",
      "lang": "en",
      "toc": [
        {
          "id": "installation",
          "text": "Installation",
          "depth": 2,
          "charIndex": 223
        },
        {
          "id": "usage",
          "text": "Usage",
          "depth": 2,
          "charIndex": 427
        },
        {
          "id": "options",
          "text": "Options",
          "depth": 2,
          "charIndex": 655
        },
        {
          "id": "supported-editors",
          "text": "Supported editors",
          "depth": 2,
          "charIndex": 1076
        },
        {
          "id": "behavior",
          "text": "Behavior",
          "depth": 2,
          "charIndex": 1387
        },
        {
          "id": "settings",
          "text": "Settings",
          "depth": 2,
          "charIndex": 1560
        },
        {
          "id": "api",
          "text": "API",
          "depth": 2,
          "charIndex": 1688
        }
      ],
      "frontmatter": {
        "description": "Open Editor plugin for React Trace — open inspected component source files in VS Code, Cursor, Windsurf, Zed, WebStorm, or IntelliJ with one click."
      },
      "version": "",
      "_relativePath": "plugins/open-editor.mdx",
      "description": "Open Editor plugin for React Trace — open inspected component source files in VS Code, Cursor, Windsurf, Zed, WebStorm, or IntelliJ with one click."
    },
    {
      "title": "Preview Plugin",
      "routePath": "/plugins/preview",
      "lang": "en",
      "toc": [
        {
          "id": "installation",
          "text": "Installation",
          "depth": 2,
          "charIndex": 236
        },
        {
          "id": "usage",
          "text": "Usage",
          "depth": 2,
          "charIndex": 436
        },
        {
          "id": "what-it-adds",
          "text": "What it adds",
          "depth": 2,
          "charIndex": 666
        },
        {
          "id": "folder-access",
          "text": "Folder access",
          "depth": 2,
          "charIndex": 1001
        },
        {
          "id": "options",
          "text": "Options",
          "depth": 2,
          "charIndex": 1634
        },
        {
          "id": "settings",
          "text": "Settings",
          "depth": 2,
          "charIndex": 2157
        }
      ],
      "frontmatter": {
        "description": "Preview plugin for React Trace — Monaco-based source preview with syntax highlighting, inline editing, and project folder access via the File System Access API."
      },
      "version": "",
      "_relativePath": "plugins/preview.mdx",
      "description": "Preview plugin for React Trace — Monaco-based source preview with syntax highlighting, inline editing, and project folder access via the File System Access API."
    }
  ]
};
          export const searchIndexHash = {
  "###en": "132d1c84"
};